import cx from 'classnames';
import {WindowFont} from '~/common/FabricInvitation/EventCreateDesign/components/CardEditor/types';
import {Button} from '~library/atoms/Button';

import './FontCategoryPills.sass';

type FontCategoryPillsProps = {
  selectedCategories: string[];
  setSelectedCategories: React.Dispatch<React.SetStateAction<string[]>>;
  setCategoryFonts: React.Dispatch<React.SetStateAction<Record<string, WindowFont[]>>>;
};

export const FontCategoryPills = ({
  selectedCategories,
  setSelectedCategories,
  setCategoryFonts,
}: FontCategoryPillsProps) => {
  const categories = ['Serif', 'Sans Serif', 'Script', 'Decorative'] as const;

  const handleOnClick = (categoryName: string) => {
    setSelectedCategories((prev: string[]) => {
      let updated: string[];

      if (prev.includes(categoryName)) {
        updated = prev.filter((c: string) => c !== categoryName);
      } else {
        updated = [...prev, categoryName];
      }

      return categories.filter((cat) => updated.includes(cat));
    });

    setCategoryFonts((prev: Record<string, WindowFont[]>) => {
      const updatedFonts = {...prev};

      if (updatedFonts[categoryName]) {
        delete updatedFonts[categoryName];
      } else {
        updatedFonts[categoryName] = window.fonts.filter((font) => font.type === categoryName);
      }
      return updatedFonts;
    });

    document.querySelector('.fonts__mobile__bottom')?.scrollTo({top: 0, behavior: 'smooth'});
  };

  return (
    <div className="fonts__category-pills">
      {categories.map((category) => (
        <Button
          key={category}
          className={cx('fonts__category-pill', {
            'fonts__category-pill--selected': selectedCategories.includes(category),
          })}
          onClick={() => handleOnClick(category)}
          rounded={true}
          data-qa-id="font-category-button"
        >
          {category}
        </Button>
      ))}
    </div>
  );
};
